import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { loadStripe } from "@stripe/stripe-js";
import Stripe from "stripe";
import { encrypt } from "../../utils";
import { translation } from '../../i18';

const Spotlight = (props) => {
  const { t } = translation();
  const navigate = useNavigate();
  const location = useLocation();
  const { contentDetail } = useSelector((state) => state.content);
  const { email } = useSelector((state) => state.auth);
  const selectedLanguage = localStorage.getItem('language');
  useEffect(() => { }, []);

  const initiateTransaction = async () => {
    if(!contentDetail?.price?.price){
      return;
    }
    const keys = Object.keys(contentDetail?.title);
    const name = contentDetail?.title[keys[0]] || '';
    let price = contentDetail?.price?.price;
    let params = {
      contentId: contentDetail?._id,
      amount: price,
      thumbnail:contentDetail.thumbnail,
      title:name
    };
    let signedParams=btoa(JSON.stringify(params));
    navigate(`/checkout?pti=${signedParams}`);
  };

  function formatISOToGMTAmPm(isoDateStr) {
    const date = new Date(isoDateStr);
    let time = date.getTimezoneOffset();
    time = date.getTime() - (time * 60 * 1000);
    date.setTime(time);
    const options = {
      timeZone: 'GMT',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      // timeZoneName: 'short'
    };

    return date.toLocaleString('en-US', options);
  }

  const watchContent = async () => {
    if (contentDetail && contentDetail.subscription_type == 'free') {
      navigate(`/player/${contentDetail?._id}/content`, { state: { from: location.pathname } });
    } else if (contentDetail && contentDetail.subscription_type == 'purchase' && contentDetail?.isAvailable) {
      navigate(`/player/${contentDetail?._id}/content`, { state: { from: location.pathname } });
    } else {
      initiateTransaction();
    }
  };

  const playTrailer = () => {
    if (contentDetail) {
      navigate(`/player/${contentDetail?._id}/trailer`, { state: { from: location.pathname } });
    }
  };

  const watchButtonText = useMemo(() => {
   let text = t('watchNow');
    if (contentDetail?.isAvailable) {
      return `${text}`;
    }
    if (contentDetail?.price?.price) {
      return `${text} ${t('for')} $${contentDetail?.price?.price}`;
    }
    return text;
  }, [contentDetail]);

  return (
    <div className="spotlight-container">
      <div className="spotlight-wrapper">
        <div className="title">{contentDetail?.title?.[selectedLanguage] || contentDetail?.title?.['en']}</div>
        <div className="tags">
          {contentDetail?.duration ? <span className="tag">{contentDetail?.duration}</span> : null}
          {contentDetail?.publish_year ? <span className="tag">{contentDetail?.publish_year}</span> : null}
          {contentDetail?.age_rating ? <span className="tag">{contentDetail?.age_rating}</span> : null}
          {contentDetail?.cast ? <span className="tag">{contentDetail?.cast}</span> : null}
        </div>
        <div className="description">{contentDetail?.description?.[selectedLanguage] || contentDetail?.description?.['en']}</div>
        <div className="button-wrapper">
          <button className="watch-button" onClick={watchContent}>
            <span className="play-icon"></span>
            <span className="btn-text">{watchButtonText}</span>
          </button>
          {contentDetail?.trailer ? <span className="trailer" onClick={playTrailer}>{t('trailer')}</span> : null}
        </div>
        {contentDetail?.expiryDate ? <div className="expiry-date"><span>{t('willExpire')}</span> {formatISOToGMTAmPm(contentDetail?.expiryDate)}</div> : null}
      </div>
    </div>
  );
};

export default React.memo(Spotlight);
